import {
  BarChart3,
  Lightbulb,
  FileDown,
  Save,
  CreditCard,
  ChartNoAxesCombined,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

// Feature Card
// function FeatureCard({ title, description, icon: Icon, badge }) {
//   return (
//     <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md transition">
//       <div className="flex items-center mb-4">
//         <div className="text-3xl">
//           <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-100">
//             <Icon className="w-6 h-6 text-emerald-600" />
//           </div>
//         </div>
//         <h3 className="text-lg font-semibold ml-3 text-slate-900 mb-2">
//           {title}
//         </h3>
//       </div>

//       <p className="text-slate-600 text-sm leading-relaxed">{description}</p>
//     </div>
//   );
// }

function FeatureCard({ title, description, icon: Icon, badge }) {
  return (
    <div className="
    cursor-pointer
      group relative
      bg-gradient-to-br from-white to-emerald-50/40
      border border-slate-200/60
      rounded-2xl p-6
      shadow-sm
      hover:shadow-xl
      hover:-translate-y-2
      transition-all duration-500
      overflow-hidden
    ">

      {/* Glow Effect */}
      <div className="absolute  inset-0 opacity-0 group-hover:opacity-100 transition duration-500">
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-emerald-300/30 blur-3xl rounded-full"></div>
      </div>

      <div className="relative z-10">

        {/* Icon + Title */}
        <div className="flex items-center mb-4">
          <div className="
            w-14 h-14 flex items-center justify-center 
            rounded-2xl 
            bg-emerald-100
            group-hover:bg-emerald-500
            transition duration-500
          ">
            <Icon className="
              w-6 h-6 
              text-emerald-600 
              group-hover:text-white
              transition duration-500
            " />
          </div>

          <h3 className="text-lg font-semibold ml-4 text-slate-900">
            {title}
          </h3>
        </div>

        {/* Description */}
        <p className="text-slate-600 text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}


export default function Home() {
   const { loginWithRedirect,isLoading} = useAuth0();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* NavigationBar */}
      <nav className="w-full fixed top-0 z-50 bg-white border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2  font-bold text-lg">
            <img src="/logo.jpeg" className="h-10 w-12 rounded-lg" alt="logo" />
            <div>
              <p className="text-green-800/70">EV Charging Station</p>
              <p className="text-black text-xs">ROI & Cost Calculator</p>
            </div>
          </div>

          {/* Links */}
          <div className="hidden md:flex items-center gap-8 text-gray-600">
           
            <a href="#features" className="hover:text-slate-900 transition">
              Features
            </a>

            {/* <button
             onClick={() =>
    loginWithRedirect({
      appState: { returnTo: "/calculator" },
    })
  }
            className="bg-emerald-400 text-white px-5 py-2 rounded-full font-semibold hover:bg-emerald-300 transition">
              Get Started
            </button> */}
            <button
  onClick={() =>
    loginWithRedirect({
      appState: { returnTo: "/calculator" },
    })
  }
  className="
    group relative inline-flex items-center justify-center
    px-6 py-2.5
    font-semibold text-white
    rounded-full
    bg-gradient-to-r from-emerald-500 to-green-400
    shadow-lg shadow-emerald-500/30
    hover:shadow-emerald-500/50
    hover:-translate-y-1
    transition-all duration-300
    overflow-hidden
  "
>
  {/* Shine animation */}
  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent 
                   translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></span>

  {/* Text */}
  <span className="relative z-10 flex items-center gap-2">
    Get Started
    <span className="transition-transform duration-300 group-hover:translate-x-1">
      →
    </span>
  </span>
</button>

          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left Content */}
        <div>
          <span className="inline-flex items-center gap-2 bg-emerald-900/20 text-green-800 px-4 py-1 rounded-full text-sm mb-6">
            EV Charging Investment Calculator
          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
            Calculate Your <span className="text-emerald-400">EV Charging</span>{" "}
            ROI Instantly
          </h1>

          {/* <p className="text-gray-600 mt-6 max-w-xl">
            Make data-driven decisions for your EV charging infrastructure.
            Estimate revenue, payback period, and long-term returns in minutes.
          </p> */}
<p className="text-gray-600 mt-6 max-w-xl">
  Make data-driven decisions for your EV charging station investment. 
  Use our EV charging ROI calculator to estimate charging station revenue, 
  payback period, profitability, and long-term return on investment for 
  your electric vehicle infrastructure.
</p>

          {/* Buttons */}
          <div className="flex gap-4 mt-8">
    
{/* <button
  onClick={() =>
    loginWithRedirect({
      appState: { returnTo: "/calculator" },
    })
  }
  className="bg-emerald-400 text-white px-6 py-3 rounded-full font-semibold"
>
  LOGIN / REGISTER TO CALCULATE →
</button> */}

<button
  onClick={() =>
    loginWithRedirect({
      appState: { returnTo: "/calculator" },
    })
  }
  className="
    group relative inline-flex items-center justify-center
    px-8 py-3
    font-semibold text-white
    rounded-full
    bg-gradient-to-r from-emerald-500 to-green-400
    shadow-lg shadow-emerald-400/30
    hover:shadow-emerald-500/50
    hover:-translate-y-1
    transition-all duration-300
    overflow-hidden
  "
>
  {/* Glow Layer */}
  <span className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition duration-300 rounded-full"></span>

  {/* Text */}
  <span className="relative z-10 flex items-center gap-2">
    LOGIN / REGISTER TO CALCULATE
    <span className="transition-transform duration-300 group-hover:translate-x-1">
      →
    </span>
  </span>
</button>

  
          </div>
        </div>

        {/* Right Glow / Visual */}
      {/* Right App Preview */}
<div className="hidden lg:flex relative justify-center items-center">
  
  {/* Glow Background */}
  <div className="absolute w-[500px] h-[500px] bg-emerald-400/20 blur-[140px] rounded-full"></div>

  {/* Image Card */}
  <div className="relative bg-white/10 backdrop-blur-xl border border-white/20 
                  rounded-2xl shadow-2xl p-1 transform hover:scale-105 
                  transition duration-500">

    <img
      src="/app-preview.png"  // 👈 Put your image path here
      alt="EV Charging ROI Calculator Preview"
      className="rounded-xl shadow-lg"
    />

  </div>
</div>

      </section>

      {/* Feature Section */}
      <section id="features" className="py-20 bg-slate-50 scroll-mt-5">
        <div className="max-w-7xl mx-auto px-6">
          {/* Section Header */}
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
              Everything You Need to Decide with{" "}
              <span className="text-green-600">Confidence</span>
            </h2>
            <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
              Comprehensive tools designed to help you evaluate every aspect of
              your EV charging investment.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard
              title="5 Year Projections"
              description="Analyze long-term profitability with detailed forecasts."
              icon={BarChart3}
            />

            <FeatureCard
              title="Key Insights & Recommendations"
              description="Actionable insights to improve ROI and decision-making."
              icon={Lightbulb}
            />

            <FeatureCard
              title="Excel & PDF Download"
              description="Export professional reports for offline analysis."
              icon={FileDown}
            />

            <FeatureCard
              title="Saved Projects"
              description="Save and revisit multiple investment scenarios."
              icon={Save}
            />

            <FeatureCard
              title="Subscription Plans As per need"
              description="As per Starter, Pro, and Business plans for every need."
              icon={CreditCard}
            />

            <FeatureCard
              title="Detailed Cost Breakdown"
              description="As per complex business model"
              icon={ChartNoAxesCombined}
            />

          </div>
        </div>
      </section>
      
      {/* CTA Section */}
<section className="relative py-8 bg-slate-50  overflow-hidden">
  {/* Glow Effect */}
  <div className="absolute inset-0 flex justify-center">
    <div className="w-[600px] h-[600px] bg-emerald-400/20 blur-[150px] rounded-full"></div>
  </div>

  <div className="relative max-w-4xl mx-auto px-6 text-center">
    <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">
      Ready to Power Your{" "}
      <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
        Investment?
      </span>
    </h2>

    <p className="mt-6 text-lg text-slate-600 max-w-2xl mx-auto">
      Join thousands of property owners and fleet managers & Charge Point Operator already
      maximizing their EV charging returns.
    </p>

    <div className="flex flex-col sm:flex-row mt-10 gap-4 items-center justify-center">
      <button 
      onClick={() =>
    loginWithRedirect({
      appState: { returnTo: "/calculator" },
    })
  }
      className="w-full  bg-gradient-to-r from-emerald-400 to-cyan-400 text-black font-semibold px-8 py-4 rounded-full hover:opacity-90 transition flex justify-center items-center gap-3 mx-auto">
        <span className="flex justify-center items-center gap-2">
        Start Calculating Now
    <span className="transition-transform duration-300 group-hover:translate-x-1">
      →
    </span>
  </span>
      </button>

    <button
  onClick={() => window.open("https://www.chargecity.co/start-an-ev-charging-station", "_blank")}
  className="group relative px-8 py-4 rounded-full font-semibold text-white 
  bg-black shadow-lg 
  transition-all duration-300 hover:scale-105 hover:shadow-2xl"
>
  <span className="flex items-center gap-2">
    🚀 Start An EV Charging Station
    <span className="transition-transform duration-300 group-hover:translate-x-1">
      →
    </span>
  </span>
</button>

    </div>
  </div>
</section>

    </div>
  );
}
